import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    auth: {}
}

const modalSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuth: (state, action) => {
            state.auth = action.payload;
        }
    }
})

export const { setAuth } = modalSlice.actions;

export default modalSlice.reducer